import './styles.css';

import React from 'react';
import { Typography } from '@vtblife/uikit';

import classname from '@search/classname/src';

const cn = classname.bind(null, 'PersonalDataPolicy');

type PersonalDataPolicyProps = {
    actionTitle?: string;
    isMobile?: boolean;
}

export const PersonalDataPolicy = ({
    actionTitle = 'Следить',
    isMobile
}: PersonalDataPolicyProps) => (
    <Typography
        tag='div'
        variant='small-alone'
        color='secondary'
        className={cn()}
    >
        {`Нажимая "${actionTitle}", вы\u00A0соглашаетесь с\u00A0условиями `} <Typography
            tag='a'
            className={cn('link', { isMobile })}
            href='https://m2.ru/support/clients/soglasheniya/privacy-policy/'
            target='_blank'
            color='primary'
        >
            политики обработки персональных данных
        </Typography>
    </Typography>
);
